import { useEffect, useState, useMemo } from "react";
import {
    getBranchUserRoles,
    getBranchUsersByRoleAndDate
} from "../../api/role.api";

import StaffAttendanceTable from "../../components/StaffAttendanceTable/StaffAttendanceTable";
import "./StaffAttendance.css";

export default function StaffAttendance() {

    const branch =
        JSON.parse(localStorage.getItem("branch"));

    const today = new Date().toISOString().split("T")[0];

    const [from, setFrom] = useState(today);
    const [to, setTo] = useState(today);
    const [status, setStatus] = useState("All");
    const [data, setData] = useState([]);
    const [teacherRoleId, setTeacherRoleId] = useState(null);
    const [loading, setLoading] = useState(false);

    // Teacher role topish
    useEffect(() => {
        const loadRole = async () => {
            const roles = await getBranchUserRoles(branch.id);

            const teacherRole = roles.find(r =>
                r.name.toLowerCase().includes("o'qituvchi") ||
                r.name.toLowerCase().includes("teacher")
            );

            if (teacherRole) {
                setTeacherRoleId(teacherRole.id);
            }
        };

        loadRole();
    }, []);

    // Data load
    useEffect(() => {
        if (!teacherRoleId) return;

        const load = async () => {
            try {
                setLoading(true);

                const formatDate = (date) => {
                    const [y, m, d] = date.split("-");
                    return `${d}.${m}.${y}`;
                };

                const result =
                    await getBranchUsersByRoleAndDate({
                        branchId: branch.id,
                        roleId: teacherRoleId,
                        date1: formatDate(from),
                        date2: formatDate(to)
                    });

                setData(result);

            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        load();
    }, [teacherRoleId, from, to]);

    // Status normalize
    const normalize = (str) =>
        str?.toLowerCase().replace(/\s+/g, "_");

    const filtered = useMemo(() => {
        return data.filter(user => {
            const day = user.dates?.[0];
            if (!day) return false;

            if (status === "All") return true;

            if (!day.status || day.status.length === 0)
                return status === "absent";

            return day.status.some(s =>
                normalize(s.name) === status
            );
        });
    }, [data, status]);

    return (
        <div className="staff-page">

            <h2 className="page-title">
                Staff Attendance
            </h2>

            <div className="filters-bar">

                <input
                    type="date"
                    value={from}
                    onChange={e => setFrom(e.target.value)}
                />

                <input
                    type="date"
                    value={to}
                    onChange={e => setTo(e.target.value)}
                />

                <select
                    value={status}
                    onChange={e => setStatus(e.target.value)}
                >
                    <option value="All">All</option>
                    <option value="came_on_time">Came On Time</option>
                    <option value="late">Late</option>
                    <option value="left_early">Left Early</option>
                    <option value="left_on_time">Left On Time</option>
                    <option value="absent">Absent</option>
                </select>

            </div>

            {loading ? (
                <p className="loading">Loading...</p>
            ) : (
                <StaffAttendanceTable data={filtered} />
            )}

        </div>
    );
}
